import React from 'react';
import { Box, Chip, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { ImageAvatar } from 'components/Avatar';
import { PaperCard } from 'components/Card';
import { isoToDateString } from 'utils/dateFormatter';
import { paths } from 'routes';
import { useLocale } from 'i18n/useLocale';
import DelegonSmallLogo from 'assets/Delegon_Small_Logo.png';

export const BlogsTabListItem = ({ blog, isPublicProfile }) => {
  const {
    blog_id,
    title,
    description,
    picture_url,
    tag,
    created_on,
    Creator,
    slug
  } = blog;
  const lang = useLocale();

  const blogLink = isPublicProfile ? paths.public.blogDetailsView(slug, lang) : paths.blogDetailsView(blog_id);

  return (
    <PaperCard
      sx={{
        flex: 1,
        boxShadow: 0,
        borderRadius: 1,
        p: 2,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Link
        component={RouterLink}
        to={blogLink}
        color="inherit"
        underline='none'
        sx={{height:1, minWidth: 0}}
      >
        <Stack flexDirection={"column"} gap={2} sx={{height:1, minWidth: 0}}>
          <Stack>
            <Box sx={{ img: { width: 1, height: 1, borderRadius: 1, maxWidth: 334, maxHeight: 187 } }}>
              <img src={picture_url} alt="blog_picture" />
            </Box>
          </Stack>
          <Stack justifyContent="space-between" gap={2} sx={{height:1, minWidth: 0}}>
            <Stack gap={2} sx={{height:1, minWidth: 0}}>
              <Chip
                label={tag}
                sx={{
                  fontSize: "0.75rem",
                  fontWeight: 500,
                  lineHeight: "20px",
                  color: "primary.light",
                  backgroundColor: "#4B6BFB0D",
                  borderRadius: "6px",
                  width: "fit-content",
                }}
              />
              <Typography
                variant="h2"
                fontSize={"0.875rem"}
                fontWeight={500}
                lineHeight={"normal"}
                sx={{
                  display: '-webkit-box',
                  minWidth: 0,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  minHeight: '36px',
                  wordBreak: 'break-word',
                  alignContent: "center",
                }}
              >
                {title}
              </Typography>
              <Typography
                variant="body2"
                fontSize={"0.75rem"}
                fontWeight={300}
                alignContent={"center"}
                sx={{
                  display: '-webkit-box',
                  minWidth: 0,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: 'vertical',
                  minHeight: '36px',
                  wordBreak: 'break-word',
                  alignContent: "center",
                }}
              >
                {description}
              </Typography>
            </Stack>
            <Stack flexDirection={"column"} sx={{alignItems: "flex-start", justifyContent: "space-between"}} gap={1}>
              <Stack flexDirection={"row"} gap={1} sx={{alignItems: "center"}}>
                <ImageAvatar
                  img={(Creator && Creator?.company_id !== 0) ? Creator?.square_logo_url : DelegonSmallLogo || ''}
                  name={(Creator && Creator?.company_id !== 0) ? Creator?.Name : "Delegon"}
                  sx={{
                    backgroundColor: "#fff",
                    width: 25,
                    height: 25,
                    img : {
                      width: 25,
                      height: 25,
                      overflow: 'hidden',
                    },
                    }}
                  />
                <Stack flexDirection={"column"}>
                  <Typography variant="body3" sx={{fontFeatureSettings: `'liga' off, 'vlig' off`, fontSize: "0.625rem", fontWeight: 400, lineHeight: "normal"}}>
                    {(Creator && Creator?.company_id !== 0) ? Creator?.Name : "Delegon"}
                  </Typography>
                  <Typography variant="body3" sx={{fontSize: "0.625rem", fontWeight: 400, lineHeight: "normal"}}>
                    {isoToDateString(created_on, false)}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Link>
    </PaperCard>
  );
};
